import styled from '@emotion/styled';
import React, { FC } from 'react';
import { colors } from '../Shared/Style/colors';

const StyledCardTitle = styled.h2({
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '0.9rem',
    lineHeight: '100%',
    padding: '11px 0',
    margin: '0px 0px 0px 0px',
    color: colors.textColor2,

    alignItems: 'center',
});

const CardSpan = styled.span({
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '0.9rem',
    lineHeight: '100%',
    padding: '11px 0',
    margin: '0px 0px 0px 0px',
    color: colors.textColor1,

    alignItems: 'center',
});
const CardTitle: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>> = ({
    children,
    ...rest
}) => {
    return <StyledCardTitle {...rest}>{children}</StyledCardTitle>;
};

export { CardTitle as default, CardSpan };
